import axios from "axios";
import api from "../../services/AxiosService";
import { SYS_CONFIG } from "../../Utils/Sysconfig";

const baseUrl = SYS_CONFIG.localBaseUrl

export const authentication = (data) => {
    var config = {
        method: "post",
        // url:"http://localhost:8085/login",
        url: baseUrl + "/login",
        headers: {
            "Content-Type": "application/json",
        },
        data: data,
    };

    return new Promise((resolve, reject) => {
        axios(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                console.error("Error occurred:", error); // Log the error for debugging

                reject(error.response);
            });
    });


}
export const logout = () => {
    return api("get", "logout", "", null)
}

